import { ThirdPartyApiClient } from '@fourthwall/services/dist/ThirdPartyApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDisconnectStreamlabsMutation = createMutationHook(
  ThirdPartyApiClient.disconnectStreamlabs,
  {
    mutationKey: ['disconnectStreamlabs'],
  },
)
